<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="postData"
      label-position="right"
      label-width="150px"
      class="form"
    >
      <el-form-item label="难度名称" prop="difficulty_name">
        <el-input
          v-model="postData.difficulty_name"
          maxlength="32"
          show-word-limit
          clearable
          placeholder="请输入 2 ~ 32 字符的难度名称"
        />
      </el-form-item>

      <el-form-item>
        <el-button v-if="isAdministrator" type="primary" @click="store" :loading="isSaving">立即添加</el-button>
        <el-button v-else type="primary" @click="applyForStore" :loading="isSaving">申请添加</el-button>
        <el-button @click="RouteConfig.courseDifficultyList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { store } from '@/api/course-difficulty';
import { store as applyStore } from '@/api/course-difficulty-add-apply';

export default {
  name: RouteConfig.courseDifficultyAdd.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    postData: {
      difficulty_name: '',
    },
    rules: {
      difficulty_name: [{ required: true, message: '请输入难度名称', trigger: 'change' }],
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  methods: {
    store() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const postData = { ...this.postData };
        if (postData.difficulty_name.length < 2) return '请输入 2 ~ 32 字符内的难度名称';

        this.isSaving = true;
        const { isError } = await store(postData);
        this.isSaving = false;
        if (!isError) RouteConfig.courseDifficultyList.push();
      });
    },
    applyForStore() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const postData = { ...this.postData };
        if (postData.difficulty_name.length < 2) return '请输入 2 ~ 32 字符内的难度名称';

        this.isSaving = true;
        const { isError } = await applyStore(postData);
        this.isSaving = false;
        if (!isError) RouteConfig.courseDifficultyAddApplyList.push();
      });
    },
  },
};
</script>
